// extracted by mini-css-extract-plugin
export var bodyRow = "_cr-d";
export var cardColumns = "_cr-e";
export var ellipsesOverflow = "_cr-2";
export var flatBottomCorners = "_cr-3";
export var flatTopCorners = "_cr-4";
export var headerActionsDropdown = "_cr-f";
export var headerBottomRow = "_cr-c";
export var headerTopRow = "_cr-b";
export var orderDetailsWrapper = "_cr-0";
export var orderInfoContainer = "_cr-1";
export var productDetails = "_cr-9";
export var productImage = "_cr-5";
export var responsiveTable = "_cr-8";
export var shipmentContainer = "_cr-a";
export var tableBottomLeft = "_cr-6";
export var tableBottomRight = "_cr-7";
export var trackingLink = "_cr-g";